.scheduleRow {
  display: flex;
  gap: 16px;
  width: 100%;

  & > * {
    flex: 1;
    min-width: 0;
  }
}
